import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';

export function* onUserKickedSaga() {
  yield call(eventBus.sendMessage, 'userLeft', { local: true }, { reason: 'kicked' });
}
